import type { CardArtFamily } from '../../lib/cardArt';

/**
 * Morandi Calm — soft filled shapes in dusty rose / sage / taupe.
 * Hand-poured ceramic vibe. Generous curves, no hard lines.
 */
export default function MorandiCardArt({ family }: { family: CardArtFamily }) {
  switch (family) {
    case 'tower':
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <rect x="14" y="8" width="8" height="30" rx="1" fill="#b87a6f" opacity="0.85" />
          <path d="M14 8 L22 8 L18 3 Z" fill="#b87a6f" />
          <circle cx="18" cy="18" r="1" fill="#fff" />
          <circle cx="18" cy="26" r="1" fill="#fff" />
          <path
            d="M28 4 Q 26 14 30 16 Q 24 24 28 32"
            stroke="#c4a87a"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      );
    case 'hermit':
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <ellipse cx="18" cy="22" rx="10" ry="14" fill="#c4a87a" opacity="0.6" />
          <circle cx="18" cy="22" r="5" fill="#f7f1e8" />
          <circle cx="18" cy="22" r="2" fill="#b87a6f" />
          <line x1="18" y1="4" x2="18" y2="8" stroke="#8a7a6f" strokeWidth="0.8" />
        </svg>
      );
    case 'star':
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(18 20)">
            {[0, 72, 144, 216, 288].map((a) => (
              <ellipse
                key={a}
                rx="3.5"
                ry="8"
                cx="0"
                cy="-5"
                transform={`rotate(${a})`}
                fill="#8a9a82"
                opacity="0.75"
              />
            ))}
            <circle r="3" fill="#f2cf7a" />
          </g>
          <path
            d="M6 36 Q 12 34, 18 36 T 30 36"
            stroke="#a0b29a"
            strokeWidth="1"
            fill="none"
            opacity="0.7"
          />
        </svg>
      );
    case 'wheel':
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="22" r="11" fill="#d4a89a" opacity="0.5" />
          <circle cx="18" cy="22" r="7" fill="#c4b398" opacity="0.7" />
          <circle cx="18" cy="22" r="2.5" fill="#b87a6f" />
        </svg>
      );
    case 'figure':
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="14" r="5" fill="#d4a89a" opacity="0.85" />
          <path
            d="M9 38 Q 9 26 18 24 Q 27 26 27 38 Z"
            fill="#c4b398"
            opacity="0.85"
          />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 36 44" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
          <circle cx="18" cy="22" r="8" fill="#c4a87a" opacity="0.7" />
        </svg>
      );
  }
}
